module.exports = __webpack_public_path__ + "static/img/contant_6.ca25d2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_8/contant_6.jpg
// module id = Fe+q
// module chunks = 0